import { NgIf } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
	selector: 'app-image-slider-dialog',
	templateUrl: './image-slider-dialog.component.html',
	styleUrls: ['./image-slider-dialog.component.scss'],
	standalone: true,
	imports: [NgIf, MatButtonModule, MatIconModule],
})
export class ImageSliderDialogComponent implements OnInit {
	images: any[] = [];
	currentIndex = 0;
	public safeVideoUrl: SafeResourceUrl | null = null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<ImageSliderDialogComponent>,
		private sanitizer: DomSanitizer
	) {}

	ngOnInit() {
		this.images = this.data?.images || [];
		this.currentIndex = this.data?.clickedImage || 0;
		this.updateSafeVideoUrl();
	}

	updateSafeVideoUrl() {
		const current = this.images[this.currentIndex];
		const videoUrl = current?.video;

		if (!videoUrl) {
			this.safeVideoUrl = null;
			return;
		}

		let embedUrl = videoUrl;

		try {
			const url = new URL(videoUrl);

			// Handle standard YouTube links
			if (url.hostname.includes('youtube.com') && url.searchParams.get('v')) {
				const videoId = url.searchParams.get('v');
				embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
			}

			// Handle shortened YouTube links (youtu.be)
			if (url.hostname.includes('youtu.be')) {
				const videoId = url.pathname.split('/').pop();
				embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
			}

			this.safeVideoUrl =
				this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
		} catch (e) {
			// Fallback in case of invalid URL
			this.safeVideoUrl =
				this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
		}
	}

	prev() {
		if (this.currentIndex > 0) {
			this.currentIndex--;
			this.updateSafeVideoUrl();
		}
	}

	next() {
		if (this.currentIndex < this.images.length - 1) {
			this.currentIndex++;
			this.updateSafeVideoUrl();
		}
	}

	close() {
		this.dialogRef.close();
	}
}
